/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/initialization-action.type';

export const setInitialization = () => ({
  type: actions.SET_INITIALIZE,
});

export const setInitializationSuccess = (data:any) => ({
  type: actions.SET_INITIALIZE_SUCCESS,
  payload: data,
});

export const setInitializationError = (error:any) => ({
  type: actions.SET_INITIALIZE_FAILURE,
  payload: error,
});
